// extracted by mini-css-extract-plugin
export default {"wrapper":"InputBlock_wrapper__CqcPH","asterisk":"InputBlock_asterisk__Kt4gt","inputLabel":"InputBlock_inputLabel__NOX0Y","inputDescription":"InputBlock_inputDescription__w0hHr"};